import {createContext} from 'react';

const CancellationContext = createContext();

export default CancellationContext;
